import { BrowserRouter as Router } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ContextProvider } from './contexts/ContextProvider';
import { apolloClient } from './lib/apollo';
import { ErrorBoundary } from './components/ErrorBoundary';
import ToastWrapper from './components/ui/ToastWrapper';
import AuthChecker from './components/AuthChecker';
import { AppRoutes } from './routes';
import './i18n/config';
import SupportWidget from './components/SupportWidget';
import BrowserNotificationInitializer from './components/BrowserNotificationInitializer';
import OfflineFallback from '@/components/OfflineFallback';
import useOnlineStatus from '@/hooks/useOnlineStatus';
import CrispChat from './components/CrispChat';
import AnalyticsConsentPrompt from './components/AnalyticsConsentPrompt';

function AppContent() {
  const isOnline = useOnlineStatus();

  // The browser going offline replaces the app with SP's offline screen rather
  // than letting every panel fail into its own red line of text.
  if (!isOnline) return <OfflineFallback fullScreen />;

  return (
    <>
      <AnalyticsConsentPrompt />
      {/* FullScreenLoader removed - was causing jank */}
      <AuthChecker>
        <BrowserNotificationInitializer />
        <ToastWrapper />
        <AppRoutes />
      </AuthChecker>
      <SupportWidget />
      <CrispChat />
    </>
  );
}

function App() {
  const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

  return (
    <ErrorBoundary>
      <GoogleOAuthProvider clientId={googleClientId ?? ''}>
        <ApolloProvider client={apolloClient}>
          <ContextProvider>
            <Router>
              <AppContent />
            </Router>
          </ContextProvider>
        </ApolloProvider>
      </GoogleOAuthProvider>
    </ErrorBoundary>
  );
}

export default App;
